module.exports = __webpack_public_path__ + "fonts/SofiaSansCondensed-VariableFont_wght.c655120e.ttf";